import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RequestStatus } from '@beef/smart-kit';
import { Modal } from '@beef/ui-kit';
import PropTypes from 'prop-types';

import { modalState } from 'constants/cheaperModal';
import { eulaDataSelector } from 'store/common/EULA/selectors';
import {
  cheaperOptionSelector,
  cheaperOptionTextSelector,
} from 'store/ProductDetails/cheaperOption/selectors';
import { getProductArticle } from 'store/ProductDetails/selectors';

import { CheaperForm } from './components/CheaperForm';
import { ModalFooter } from './components/ModalFooter';
import { PersonalData } from './components/PersonalData';

export const CheaperModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(modalState.FORM);
  const { isSending, isSendingSuccess } = useSelector(cheaperOptionSelector);
  const texts = useSelector(cheaperOptionTextSelector);
  const article = useSelector(getProductArticle);
  const userLicense = useSelector(eulaDataSelector);

  useEffect(() => {
    const currStep = isSendingSuccess ? modalState.SUCCESS : modalState.FORM;
    setStep(currStep);
  }, [isSendingSuccess]);

  const onCloseModal = () => {
    onClose();
    setStep(modalState.FORM);
  };

  const backButtonClick = useCallback(() => {
    setStep(modalState.FORM);
  }, []);

  const onUserLicense = useCallback(() => {
    setStep(modalState.EULA);
  }, []);

  const isFooter = step === modalState.SUCCESS || step === modalState.FORM;

  return (
    <Modal
      actionBar={
        isFooter ?
          <ModalFooter onCloseModal={onCloseModal} onUserLicense={onUserLicense} step={step} />
        : undefined
      }
      headerBarConfig={
        step === modalState.EULA ?
          {
            backButtonClick,
            backButtonText: 'назад',
          }
        : undefined
      }
      isOpen={isOpen}
      onClose={onCloseModal}
      size="m"
    >
      {step === modalState.FORM && (
        <CheaperForm article={article} isOpen={isOpen} isSending={isSending} texts={texts} />
      )}
      {step === modalState.EULA && <PersonalData userLicense={userLicense} />}
      {step === modalState.SUCCESS && (
        <RequestStatus
          description={texts?.done_message}
          img={{
            src: 'https://static.beeline.ru/upload/images/e-shop/icons/Congratulations.jpg',
          }}
          title={texts?.done_head}
        />
      )}
    </Modal>
  );
};

CheaperModal.propTypes = {
  isOpen: PropTypes.object,
  onClose: PropTypes.func,
};
